import { createContext } from "react";
import { IExpressionEvaluatorContext } from "../Models/IExpressionEvaluatorContext";

const ExpressionEvaluatorContext = createContext<IExpressionEvaluatorContext | undefined>(undefined);

export default ExpressionEvaluatorContext;
